import React, { createContext, useState, useMemo, useContext } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { getTheme } from '../styles/theme'

export const ColorModeContext = createContext({ toggleColorMode: () => { } })

export const useColorMode = () => {
    return useContext(ColorModeContext)
}

export const CustomThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        const savedMode = localStorage.getItem('themeMode')
        return savedMode || 'light'
    })

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => {
                    const newMode = prevMode === 'light' ? 'dark' : 'light'
                    localStorage.setItem('themeMode', newMode)
                    return newMode
                })
            },
            mode,
        }),
        [mode],
    )

    const theme = useMemo(() => getTheme(mode), [mode])

    return (
        <ColorModeContext.Provider value={colorMode}>
            <MuiThemeProvider theme={theme}>
                {children}
            </MuiThemeProvider>
        </ColorModeContext.Provider>
    )
}
